import { ADViewModule } from './../pages/ad-view/ad-view.module';
//Ionic module
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { MyApp } from './app.component';
import { HttpModule } from '@angular/http';
import { Network } from '@ionic-native/network';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { CommonHeaderComponentModule } from '../components/common-header/common-header.module';
import { InAppBrowser } from '@ionic-native/in-app-browser';

//Provider
import { CoreProvider } from './../providers/core-service/core-service';
import { EndpointServiceProvider } from '../providers/endpoint-service/endpoint-service';
import { PushServiceProvider } from './../providers/push-service/push-service';
import { FirebaseServiceProvider } from './../providers/firebase-service/firebase-service';
import { NetworkConnectionProvider } from './../providers/network-connection/network-connection';

//Firebase
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { FIREBASE_CONFIG } from './app.firebase.config';

//Module
import { LoginPageModule } from '../pages/login/login.module';
import { WeekViewModule } from '../pages/week-view/week-view.module';
import { FilterViewModule } from './../pages/filter-view/filter-view.module';
import { TimeReportingModule } from '../pages/time-reporting/time-reporting.module';
import { WebFilterViewPageModule } from './../pages/web-filter-view/web-filter-view.module';
import { WebWeeklyViewPageModule } from './../pages/web-weekly-view/web-weekly-view.module';

import { Keyboard } from '@ionic-native/keyboard';
import { ModalEditPageModule } from '../pages/modal-edit/modal-edit.module';
import { ComponentsModule } from '../components/components.module';

@NgModule({
  declarations: [
    MyApp
    ],
  imports: [
    BrowserModule,
    HttpModule,
    LoginPageModule,
    WeekViewModule,
    WebWeeklyViewPageModule,
    WebFilterViewPageModule,
    TimeReportingModule,
    FilterViewModule,
    ADViewModule,
    ComponentsModule,
    CommonHeaderComponentModule,
    ModalEditPageModule,
    AngularFireModule.initializeApp(FIREBASE_CONFIG),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    IonicModule.forRoot(MyApp)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [
    StatusBar,
    SplashScreen,
    InAppBrowser,
    Keyboard,
    FirebaseServiceProvider,
    EndpointServiceProvider,
    PushServiceProvider,
    NetworkConnectionProvider,
    CoreProvider,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    Network
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts